import React, { useState, useEffect } from "react";
import { Navigation }   from "./components/navigation";
import { Header }       from "./components/header";
import { Features }     from "./components/features";
import { Stats }        from "./components/stats";
import { About }        from "./components/about";
import { Services }     from "./components/services";
import { Method }       from "./components/method";
import { Industries }   from "./components/industries";
import { CaseStudies }  from "./components/casestudies";
import { Comparison }   from "./components/comparison";
import { Gallery }      from "./components/gallery";
import { Pricing }      from "./components/pricing";
import { Testimonials } from "./components/testimonials";
import { Team }         from "./components/Team";
import { Contact }      from "./components/contact";
import JsonData         from "./data/data.json";
import SmoothScroll     from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [d, setD] = useState({});
  useEffect(() => { setD(JsonData); }, []);

  return (
    <div>
      <Navigation   data={d.Navigation} />
      <Header       data={d.Header} />
      <Features     data={d.Features}     section={d.FeaturesSection} />
      <Stats        data={d.Stats} />
      <About        data={d.About}        section={d.AboutSection} />
      <Services     data={d.Services}     section={d.ServicesSection} />
      <Method       data={d.Method}       section={d.MethodSection} />
      <Industries   data={d.Industries}   section={d.IndustriesSection} />
      <CaseStudies  data={d.CaseStudies}  section={d.CaseStudiesSection} />
      <Comparison   data={d.Comparison} />
      <Gallery      data={d.Gallery}      section={d.GallerySection} />
      <Pricing      data={d.Pricing}      section={d.PricingSection} />
      <Testimonials data={d.Testimonials} section={d.TestimonialsSection} />
      <Team         data={d.Team}         section={d.TeamSection} />
      <Contact      data={{ ...d.Contact, _footer: d.Footer }} />
    </div>
  );
};

export default App;
